import { FiMinus, FiPlus, FiTrash } from "react-icons/fi"
import useSetlist from "../hooks/useSetlist"
import { useStorePads } from "../store"
import useInput from "../hooks/useInput"
import ModalButton from "./ModalButton"
import FormSetList from "./FormSetList"
import { BsArrowLeft } from "react-icons/bs"
import { BsPlayFill, BsStopFill } from "react-icons/bs"

export default function SetList() {
    const { songs, filteredSong, fixedSong, removeSong } = useSetlist()
    const searchInput = useInput("")
    const playback = useStorePads((state) => state.playback)
    const activateSongSettings = useStorePads((state) => state.activateSongSettings)
    const stopPlayback = useStorePads((state) => state.stopPlayback)
    const showSetList = useStorePads((state) => state.showSetList)
    const toggleSetList = useStorePads((state) => state.toggleSetList)

    const handlePlaybackToggle = (song) => {
        const isCurrentSong = playback?.source === 'setlist'
            && playback?.library === song.library
            && playback?.note === song.key
            && playback?.title === song.title

        if (isCurrentSong) {
            stopPlayback()
            return
        }

        activateSongSettings(song)
    }

    const handleReset = (song) => {
        if (playback?.source === 'setlist' && playback?.title === song.title) {
            stopPlayback()
        }
    }

    const noOp = () => { }

    const listSong = filteredSong(searchInput.value)
    const width = showSetList ? 'w-full' : 'w-0'

    if (songs.length === 0) {
        return (
            <div className={`absolute right-0 sm:relative bg-neutral-900 max-w-[790px] min-h-dvh ${width} transition-all duration-100 overflow-hidden ml-auto flex flex-col gap-4 items-center justify-around py-4`}>
                <button className="flex items-center gap-2 justify-center" onClick={toggleSetList}>
                    <BsArrowLeft size={24} />
                    Cerrar
                </button>
                <picture className={`flex flex-col justify-center gap-2 w-60 text-center`}>
                    <img className="w-full" src="/empty-playlist.svg" alt="empty playlist" />
                    <span className="font-semibold">No hay nada en la lista aún</span>
                </picture>
                <ModalButton
                    className="bg-neutral-900 flex items-center gap-2 font-semibold"
                    buttonContent={
                        <>
                            <FiPlus size={24} />
                            Agregar
                        </>
                    }
                >
                    <FormSetList />
                </ModalButton>
            </div>
        )
    }

    return (
        <div className={`absolute right-0 sm:relative bg-neutral-900 max-w-[790px] min-h-dvh ${width} transition-all duration-100 overflow-hidden ml-auto`}>
            <div className={`sticky top-[-16px] pt-2 left-0 mb-4 z-20 bg-neutral-800 p-2`}>
                <div className="flex items-center justify-between">
                    <div className="flex items-center gap-2">
                        <button onClick={toggleSetList}>
                            <BsArrowLeft size={24} />
                        </button>
                        <h4 className="text-xl font-semibold mb-2">Setlist</h4>
                    </div>
                    <ModalButton
                        className="bg-neutral-900 flex items-center gap-2 font-semibold"
                        buttonContent={
                            <>
                                <FiPlus size={24} />
                                Agregar
                            </>
                        }
                    >
                        {({ close }) => <FormSetList onSubmit={close} />}
                    </ModalButton>
                </div>
                <input
                    className="w-full md:text-2xl"
                    type="text"
                    placeholder="Buscar..."
                    onChange={searchInput.handleChange}
                    value={searchInput.value}
                />
            </div>
            <div>
                {
                    listSong.sort((a, b) => b.fixed - a.fixed).map((song) => {
                        const isPlaying = playback?.library === song.library
                            && playback?.note === song.key
                            && playback?.title === song.title
                        const isFixed = song?.fixed
                        return (
                            <div
                                key={song.title}
                                className={`flex active:bg-neutral-700 border-b border-neutral-700 py-2 px-1 items-center justify-between`}
                            >
                                <div className={`w-full ${!isFixed ? 'opacity-30' : ''} grid grid-cols-[40px_minmax(40px,1fr)] gap-2`}>
                                    <div className="flex flex-col items-center justify-center gap-1">
                                        <p className="flex flex-col items-center justify-center text-xs bg-black bg-opacity-50 text-white font-semibold rounded-md px-2 py-1">
                                            {song.key}
                                        </p>
                                        <p className="text-[10px] text-white/70 text-center">{song.bpm || '--'} BPM</p>
                                    </div>
                                    <div className="grid grid-cols-[1fr_40px] gap-2">
                                        <div className="overflow-hidden">
                                            <h4 className="font-semibold truncate text-ellipsis">{song.title}</h4>
                                            <span className={`italic`}>{song.library}</span>
                                        </div>
                                        {
                                            isPlaying && (
                                                <div className="icon-audio-meter">
                                                    <div className="bars-meter"></div>
                                                    <div className="bars-meter"></div>
                                                    <div className="bars-meter"></div>
                                                    <div className="bars-meter"></div>
                                                </div>
                                            )
                                        }
                                    </div>
                                </div>
                                <div className={`flex items-stretch gap-1`}>
                                    <button
                                        className="bg-transparent p-1 border-none"
                                        onClick={() => isFixed ? handlePlaybackToggle(song) : noOp()}
                                        title={isPlaying ? 'Detener canción' : 'Reproducir canción'}
                                    >
                                        {isPlaying ? <BsStopFill size={24} /> : <BsPlayFill size={24} />}
                                    </button>
                                    <button className="bg-transparent p-1 border-none" onClick={() => removeSong(song, handleReset)}>
                                        <FiTrash size={24} />
                                    </button>
                                    <button className="bg-transparent p-1 border-none" onClick={() => fixedSong(song, handleReset)}>
                                        {isFixed ? <FiMinus size={24} /> : <FiPlus size={24} />}
                                    </button>
                                </div>
                            </div>
                        )
                    })
                }
            </div>
        </div>
    )
}
